import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Card, Col, Row } from "react-bootstrap";
import '../About.scss';

const Experience = () => {
  useEffect(() => {
    AOS.init({duration:2000});
  }, []);

    return (
      <Row>
        <Col md={6} xs={12} className="pb-4">
          <Card data-aos="fade-down-right" className="h-100 experience">
            <Card.Body>
              <div>
                <h5>Frontend Developer at MatchPoint Solutions</h5>
                <button>November, 2021 - Present</button>
              </div>
              <p className="self-content">
                MatchPoint Solutions is a USA based Software company. Currently, I am working as a Frontend Software Developer on maintenance team. Besides that, I am providing support to build micro-frontend and collaborating with backend developers.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} xs={12} className="pb-4">
          <Card data-aos="fade-down-left" className="h-100 experience">
            <Card.Body>
              <div>
                <h5>Frontend Developer at Zaagrrow Inc.</h5>
                <button>Jun, 2021 - October, 2021</button>
              </div>
              <p className="self-content">
                Zaagrrow Inc. is a Bangladeshi Software Company. They are providing services like Innovation and Product Development, Business Systems and Automation, and so on. My job was converted design into business logic.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} xs={12} className="pb-4">
          <Card data-aos="fade-up-right" className="h-100 experience">
            <Card.Body>
              <div>
                <h5>Collage</h5>
                <button>May, 2017 - July, 2019</button>
              </div>
              <p className="self-content">
               I completed my intermediate from Senbagh Government Collage. It's well known institution in Senbagh area.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} xs={12} className="pb-4">
          <Card data-aos="fade-up-left" className="h-100 experience">
            <Card.Body>
              <div>
                <h5>Bachelor Degree</h5>
                <button>October, 2019 - Present</button>
              </div>
              <p className="self-content">
              Currently, I am taking my post graduation in Physics from National University.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
};

export default Experience;